export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const SET_ABSTRACTS = "SET_ABSTRACTS";
export const SET_ABSTRACT_DEVICES = "SET_ABSTRACT_DEVICES";
